module.exports = __webpack_public_path__ + "static/banner_home_desktop-bca36e8e48c5b13c50998ed8bb229371.jpg";